<header class="bg-white shadow-sm border-b border-gray-200 shadow-md">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Left side: scottishpower Logo + Navigation Menu -->
      <div class="flex items-center space-x-8">
        <!-- scottishpower Logo -->
        <div class="flex-shrink-0">
          <div class="flex items-center">
            <a href="https://www.scottishpower.co.uk/" target="_blank" rel="noopener noreferrer">
              <img src="https://assets.perse.io/sp_logo/SP_Logo_singleLine.svg" alt="ScottishPower Logo" class="h-8">
            </a>
          </div>
        </div>

        <!-- Navigation Menu (Desktop) -->
        <nav class="hidden lg:flex space-x-8">
          <div class="relative group">
            <button class="flex items-center text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
              Energy
              <svg class="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>

            <!-- Energy Dropdown Menu -->
            <div
              class="absolute left-0 mt-2 w-80 bg-white rounded-md shadow-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 border border-gray-200">
              <div class="py-2">
                <!-- New Business Customers Section -->
                <div class="px-4 py-2 border-b border-gray-100">
                  <h3 class="text-sm font-semibold text-gray-900 mb-2">New Business Customers</h3>
                  <a href="https://www.scottishpower-businesssales.co.uk/" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Get a quote
                  </a>
                  <a href="https://www.scottishpower.co.uk/business/our-tariffs" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Our tariffs
                  </a>
                </div>

                <!-- Existing Business Customers Section -->
                <div class="px-4 py-2 border-b border-gray-100">
                  <h3 class="text-sm font-semibold text-gray-900 mb-2">Existing Business Customers</h3>
                  <a href="https://www.scottishpower.co.uk/business/renewals" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Renewals
                  </a>
                  <a href="https://www.scottishpower.co.uk/business/our-tariffs" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    About our tariffs
                  </a>
                  <a href="https://www.scottishpower.co.uk/business/smart-meters" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Smart meters
                  </a>
                  <a href="https://www.scottishpower.co.uk/mobile-apps" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Download the app
                  </a>
                  <a href="https://www.scottishpower.co.uk/small-business/saving-energy" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Energy efficiency
                  </a>
                  <a href="https://www.scottishpower.co.uk/register" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Register for an online account
                  </a>
                  <a href="https://login.scottishpower.co.uk/u/login?state=hKFo2SBvZHRuVjVWWHNNbHZEdzhyNmFtNEJjMC03NlUwQXlDSaFur3VuaXZlcnNhbC1sb2dpbqN0aWTZIEw5YTVNT1ZaOGRvbGw3bEtBZ2RwTFFNZ3dKVEFZa2Nlo2NpZNkgdjQyZlBnZ1NWTll5NkdPSngxQ0NvQ1JIVGJtMWI0MW0"
                    target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Moving premises
                  </a>
                </div>

                <!-- Commercial Customers Section -->
                <div class="px-4 py-2">
                  <h3 class="text-sm font-semibold text-gray-900 mb-2">Commercial Customers</h3>
                  <a href="https://www.scottishpower.co.uk/commercial-business/products" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Energy tariffs
                  </a>
                  <a href="https://www.scottishpower.co.uk/commercial-business/additional-services/ppa" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Power purchase agreement
                  </a>
                  <span class="block px-2 py-2 text-sm text-gray-400 cursor-not-allowed">
                    Green hydrogen (Coming soon)
                  </span>
                  <a href="https://www.scottishpower.co.uk/commercial-business/additional-services/commercial-metering"
                    target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Commercial metering
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="relative group">
            <button class="flex items-center text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
              Green solutions
              <svg class="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>

            <!-- Green Solutions Dropdown Menu -->
            <div
              class="absolute left-0 mt-2 w-80 bg-white rounded-md shadow-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 border border-gray-200">
              <div class="py-2">
                <!-- Transport Section -->
                <div class="px-4 py-2 border-b border-gray-100">
                  <h3 class="text-sm font-semibold text-gray-900 mb-2">Transport</h3>
                  <a href="https://www.scottishpower.co.uk/business/ev-charging" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Electricity vehicle charging solutions
                  </a>
                  <a href="https://www.scottishpower.co.uk/business/ev-charging/public" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Become a public charging host
                  </a>
                  <a href="https://www.scottishpower.co.uk/business/ev-charging/business" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Business EV charging
                  </a>
                  <a href="https://www.scottishpower.co.uk/business/ev-charging/fleet" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Fleet EV charging
                  </a>
                  <a href="https://www.scottishpower.co.uk/business/ev-charging/shared" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Shared EV charging
                  </a>
                </div>

                <!-- Solar Section -->
                <div class="px-4 py-2 border-b border-gray-100">
                  <h3 class="text-sm font-semibold text-gray-900 mb-2">Solar</h3>
                  <a href="https://www.scottishpower.co.uk/business/solar" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Solar solutions
                  </a>
                  <a href="https://www.scottishpower.co.uk/smart-export-guarantee" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Smart export guarantee
                  </a>
                </div>

                <!-- Heat Section -->
                <div class="px-4 py-2">
                  <h3 class="text-sm font-semibold text-gray-900 mb-2">Heat</h3>
                  <a href="https://www.scottishpower.co.uk/business/heat" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Heat solutions
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="relative group">
            <button class="flex items-center text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
              Help
              <svg class="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>

            <!-- Help Dropdown Menu -->
            <div
              class="absolute left-0 mt-2 w-80 bg-white rounded-md shadow-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 border border-gray-200">
              <div class="py-2">
                <!-- Support Links -->
                <div class="px-4 py-2">
                  <a href="https://www.scottishpower.co.uk/small-business/customer-services" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Small business support
                  </a>
                  <a href="https://www.scottishpower.co.uk/commercial-business/customer-services" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Commercial business support
                  </a>
                  <a href="https://www.scottishpower.co.uk/small-business/saving-energy" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Energy efficiency
                  </a>
                  <a href="https://www.scottishpower.co.uk/getintouch-sme" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Get in touch
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="relative group">
            <button class="flex items-center text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium">
              About us
              <svg class="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>

            <!-- About Us Dropdown Menu -->
            <div
              class="absolute left-0 mt-2 w-80 bg-white rounded-md shadow-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 border border-gray-200">
              <div class="py-2">
                <!-- About Us Links -->
                <div class="px-4 py-2">
                  <a href="https://www.scottishpower.co.uk/business/about-us" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    About us
                  </a>
                  <a href="https://www.scottishpower.co.uk/small-business/news" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Our blogs
                  </a>
                  <a href="https://www.scottishpower.co.uk/small-business/saving-energy/case-studies" target="_blank"
                    class="block px-2 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded transition-colors duration-150">
                    Case studies
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <!-- Right side buttons (Desktop) -->
      <div class="hidden lg:flex items-center space-x-4">
        <!-- My Account Button -->
        <a href="https://login.scottishpower.co.uk/u/login" target="_blank" rel="noopener noreferrer"
          class="flex items-center text-sp-green-500 text-sm font-bold transition-colors duration-200">
          <svg class="w-4 h-4 mr-1" fill="currentColor" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          My account
        </a>

        <!-- Get a Quote Button -->
        <a href="https://www.scottishpower-businesssales.co.uk/" target="_blank" rel="noopener noreferrer"
          class="bg-sp-green-500 hover:bg-sp-green-600 text-white px-4 py-2 rounded text-sm font-medium transition-colors duration-200">
          Get a quote
        </a>
      </div>

      <!-- Mobile menu button -->
      <button class="lg:hidden text-sp-gray-500 hover:text-sp-gray-700 p-2 transition-colors duration-200"
        (click)="toggleMobileMenu()" [attr.aria-expanded]="isMobileMenuOpen">
        <svg class="h-6 w-6 transition-transform duration-300 ease-in-out" [class.rotate-180]="isMobileMenuOpen"
          fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path *ngIf="!isMobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16">
          </path>
          <path *ngIf="isMobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M6 18L18 6M6 6l12 12">
          </path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Mobile Navigation Menu -->
  <div class="lg:hidden border-t border-gray-200 bg-white transition-all duration-300 ease-in-out"
    [class]="isMobileMenuOpen ? 'block' : 'hidden'">

    <!-- Navigation Links -->
    <div class="px-4 py-3 space-y-1 border-b border-gray-100">
      <!-- Energy Menu Item with Dropdown -->
      <div class="space-y-1">
        <button
          class="flex items-center justify-between w-full px-3 py-3 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-all duration-200"
          (click)="toggleMobileEnergyDropdown()">
          Energy
          <svg class="h-5 w-5 transition-transform duration-200" [class.rotate-180]="isMobileEnergyDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>

        <!-- Energy Dropdown Content -->
        <div class="transition-all duration-300 ease-in-out bg-gray-50 rounded-md"
          [class]="isMobileEnergyDropdownOpen ? 'block' : 'hidden'">
          <div class="p-3 space-y-3">
            <!-- New Business Customers -->
            <div class="border-b border-gray-200 pb-3">
              <p class="text-sm font-semibold text-gray-900 mb-2">New Business Customers</p>
              <div class="space-y-1">
                <a href="https://www.scottishpower-businesssales.co.uk/" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Get a quote
                </a>
                <a href="https://www.scottishpower.co.uk/business/our-tariffs" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Our tariffs
                </a>
              </div>
            </div>

            <!-- Existing Business Customers -->
            <div class="border-b border-gray-200 pb-3">
              <p class="text-sm font-semibold text-gray-900 mb-2">Existing Business Customers</p>
              <div class="space-y-1">
                <a href="https://www.scottishpower.co.uk/business/renewals" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Renewals
                </a>
                <a href="https://www.scottishpower.co.uk/business/our-tariffs" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  About our tariffs
                </a>
                <a href="https://www.scottishpower.co.uk/business/smart-meters" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Smart meters
                </a>
                <a href="https://www.scottishpower.co.uk/mobile-apps" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Download the app
                </a>
                <a href="https://www.scottishpower.co.uk/small-business/saving-energy" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Energy efficiency
                </a>
                <a href="https://www.scottishpower.co.uk/register" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Register for an online account
                </a>
                <a href="https://login.scottishpower.co.uk/u/login?state=hKFo2SBvZHRuVjVWWHNNbHZEdzhyNmFtNEJjMC03NlUwQXlDSaFur3VuaXZlcnNhbC1sb2dpbqN0aWTZIEw5YTVNT1ZaOGRvbGw3bEtBZ2RwTFFNZ3dKVEFZa2Nlo2NpZNkgdjQyZlBnZ1NWTll5NkdPSngxQ0NvQ1JIVGJtMWI0MW0"
                  target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Moving premises
                </a>
              </div>
            </div>

            <!-- Commercial Customers -->
            <div>
              <p class="text-sm font-semibold text-gray-900 mb-2">Commercial Customers</p>
              <div class="space-y-1">
                <a href="https://www.scottishpower.co.uk/commercial-business/products" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Energy tariffs
                </a>
                <a href="https://www.scottishpower.co.uk/commercial-business/additional-services/ppa" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Power purchase agreement
                </a>
                <span class="block px-2 py-1.5 text-sm text-gray-400 cursor-not-allowed">
                  Green hydrogen (Coming soon)
                </span>
                <a href="https://www.scottishpower.co.uk/commercial-business/additional-services/commercial-metering"
                  target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Commercial metering
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Green Solutions Menu Item with Dropdown -->
      <div class="space-y-1">
        <button
          class="flex items-center justify-between w-full px-3 py-3 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-all duration-200"
          (click)="toggleMobileGreenSolutionsDropdown()">
          Green solutions
          <svg class="h-5 w-5 transition-transform duration-200" [class.rotate-180]="isMobileGreenSolutionsDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>

        <!-- Green Solutions Dropdown Content -->
        <div class="transition-all duration-300 ease-in-out bg-gray-50 rounded-md"
          [class]="isMobileGreenSolutionsDropdownOpen ? 'block' : 'hidden'">
          <div class="p-3 space-y-3">
            <!-- Transport -->
            <div class="border-b border-gray-200 pb-3">
              <p class="text-sm font-semibold text-gray-900 mb-2">Transport</p>
              <div class="space-y-1">
                <a href="https://www.scottishpower.co.uk/business/ev-charging" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Electricity vehicle charging solutions
                </a>
                <a href="https://www.scottishpower.co.uk/business/ev-charging/public" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Become a public charging host
                </a>
                <a href="https://www.scottishpower.co.uk/business/ev-charging/business" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Business EV charging
                </a>
                <a href="https://www.scottishpower.co.uk/business/ev-charging/fleet" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Fleet EV charging
                </a>
                <a href="https://www.scottishpower.co.uk/business/ev-charging/shared" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Shared EV charging
                </a>
              </div>
            </div>

            <!-- Solar -->
            <div class="border-b border-gray-200 pb-3">
              <p class="text-sm font-semibold text-gray-900 mb-2">Solar</p>
              <div class="space-y-1">
                <a href="https://www.scottishpower.co.uk/business/solar" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Solar solutions
                </a>
                <a href="https://www.scottishpower.co.uk/smart-export-guarantee" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Smart export guarantee
                </a>
              </div>
            </div>

            <!-- Heat -->
            <div>
              <p class="text-sm font-semibold text-gray-900 mb-2">Heat</p>
              <div class="space-y-1">
                <a href="https://www.scottishpower.co.uk/business/heat" target="_blank"
                  class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
                  Heat solutions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Help Menu Item with Dropdown -->
      <div class="space-y-1">
        <button
          class="flex items-center justify-between w-full px-3 py-3 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-all duration-200"
          (click)="toggleMobileHelpDropdown()">
          Help
          <svg class="h-5 w-5 transition-transform duration-200" [class.rotate-180]="isMobileHelpDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>

        <!-- Help Dropdown Content -->
        <div class="transition-all duration-300 ease-in-out bg-gray-50 rounded-md"
          [class]="isMobileHelpDropdownOpen ? 'block' : 'hidden'">
          <div class="p-3 space-y-1">
            <a href="https://www.scottishpower.co.uk/small-business/customer-services" target="_blank"
              class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
              Small business support
            </a>
            <a href="https://www.scottishpower.co.uk/commercial-business/customer-services" target="_blank"
              class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
              Commercial business support
            </a>
            <a href="https://www.scottishpower.co.uk/small-business/saving-energy" target="_blank"
              class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
              Energy efficiency
            </a>
            <a href="https://www.scottishpower.co.uk/getintouch-sme" target="_blank"
              class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
              Get in touch
            </a>
          </div>
        </div>
      </div>


      <!-- About Us Menu Item with Dropdown -->
      <div class="space-y-1">
        <button
          class="flex items-center justify-between w-full px-3 py-3 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-all duration-200"
          (click)="toggleMobileAboutUsDropdown()">
          About us
          <svg class="h-5 w-5 transition-transform duration-200" [class.rotate-180]="isMobileAboutUsDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>

        <!-- About Us Dropdown Content -->
        <div class="transition-all duration-300 ease-in-out bg-gray-50 rounded-md"
          [class]="isMobileAboutUsDropdownOpen ? 'block' : 'hidden'">
          <div class="p-3 space-y-1">
            <a href="https://www.scottishpower.co.uk/business/about-us" target="_blank"
              class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
              About us
            </a>
            <a href="https://www.scottishpower.co.uk/small-business/news" target="_blank"
              class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
              Our blogs
            </a>
            <a href="https://www.scottishpower.co.uk/small-business/saving-energy/case-studies" target="_blank"
              class="block px-2 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-white rounded transition-colors duration-150">
              Case studies
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- My Account Section -->
    <div class="px-4 py-3">
      <button
        class="flex items-center w-full px-3 py-3 text-base font-medium text-sp-green-500 hover:text-sp-green-600 hover:bg-sp-gray-50 rounded-md transition-all duration-200"
        (click)="closeMobileMenu()">
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
        </svg>
        My account
        <svg class="h-5 w-5 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
    </div>
  </div>
</header>